<!-- Appointment Initial DIV load for PHYSICAL to book initial appointment -->
<ng-container *ngIf="false">
	<div class="coaching-appt-container mb-4" *ngIf="eligibleForPE">
		<div class="coaching-appt-text">
			<div class="coaching-appt-header mb-4">
				<img src="assets/images/ehe_color_cross1.svg" alt="EHE Logo" />
				<span
					class="coaching-appt-header-text ml-3"
					[translate]="'health-coach.sections.wellness.coaching-appointment.pulse-physical'">
					Pulse Physical & Health Coaching
				</span>
			</div>
			<h2
				class="coaching-appt-title mb-4"
				[translate]="'health-coach.sections.wellness.coaching-appointment.pulse-physical-initial.title'">
				Get started with an in-person exam!
			</h2>
			<div class="coaching-appt-body">
				<p
					class="mb-4"
					[translate]="'health-coach.sections.wellness.coaching-appointment.pulse-physical-initial.body-1'">
					Pulse Physical is our comprehensive in-person physical exam. It includes all tests that are clinically
					indicated for your needs, plus more than twice the amount of time you'd usually get with a doctor to discuss
					your health risks and concerns.
				</p>
				<p [translate]="'health-coach.sections.wellness.coaching-appointment.pulse-physical-initial.body-2'">
					Your doctor will also help you make decisions about the screenings you might need and post-exam follow-ups.
					After your exam, you'll be automatically eligible to start working with a personal Health Coach coach on your
					goals.
				</p>
			</div>
			<div class="coaching-appt-button-container book-now">
				<app-button-common
					appEheAnalytics
					[data]="analyticsData"
					appGoogleAnalytics
					[eventData]="{
						eventCategory: 'Button',
						eventAction: 'Click - Book Now',
						eventLabel: 'Pulse Physical Coaching - Book Now'
					}"
					[buttonTextKey]="'health-coach.sections.wellness.coaching-appointment.pulse-physical-initial.button'"
					(clickEvent)="bookPPAppointment()">
				</app-button-common>
			</div>
		</div>
		<div class="coaching-appt-image-container">
			<div class="coaching-appt-image-wrapper coaching-appt-image-pp"></div>
		</div>
	</div>
</ng-container>

<!-- Appointment Initial DIV load for HEALTH COACHING to book initial appointment -->
<ng-container>
	<div class="coaching-appt-container mb-4" *ngIf="!hasFutureConfirmedAppt">
		<div class="coaching-appt-text">
			<div class="coaching-appt-header mb-4">
				<img src="assets/images/ehe_color_cross1.svg" alt="EHE Logo" />
				<span
					class="coaching-appt-header-text ml-3"
					[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching'">
					Health Coaching
				</span>
			</div>
			<h2
				class="coaching-appt-title mb-4"
				[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-initial.title'">
				You are eligible for our Health Coaching program!
			</h2>
			<div class="coaching-appt-body">
				<p
					class="mb-4"
					[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-initial.body-1'">
					Our health coaches are trained and credentialed counselors, nutritionists, and exercise physiologists who work
					to identify simple lifestyle adjustments you can make to improve your overall health in areas such as
					exercise, sleep, mental health, nutrition, weight management, stress, and more.
				</p>
				<p [translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-initial.body-2'">
					You can book a phone or video session with a health coach after completing your Pulse Physical exam.
				</p>
			</div>
			<div class="coaching-appt-button-container book-now">
				<app-button-common
					appEheAnalytics
					[data]="analyticsData"
					appGoogleAnalytics
					[eventData]="{
						eventCategory: 'Button',
						eventAction: 'Click - Book Now',
						eventLabel: 'Health Coaching - Book Now'
					}"
					[buttonTextKey]="'health-coach.sections.wellness.coaching-appointment.health-coaching-initial.button'"
					(clickEvent)="bookHCAppointment()">
				</app-button-common>
			</div>
		</div>
		<div class="coaching-appt-image-container">
			<div class="coaching-appt-image-wrapper coaching-appt-image-hc"></div>
		</div>
	</div>

	<div class="coaching-appt-container mb-4" *ngIf="hasFutureConfirmedAppt">
		<div class="coaching-appt-text">
			<div class="coaching-appt-header mb-4">
				<img src="assets/images/ehe_color_cross1.svg" alt="EHE Logo" />
				<span
					class="coaching-appt-header-text ml-3"
					[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching'">
					Health Coaching
				</span>
			</div>
			<h2
				class="coaching-appt-title mb-4"
				[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-appt-booked.title'">
				Confirmed: Your Health Coaching session is booked!
			</h2>
			<div class="coaching-appt-body">
				<p
					class="mb-4"
					[translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-appt-booked.body-1'">
					Our health coaches are trained and credentialed experts in range of areas. They provide personalized plans and
					resources to improve daily habits related to exercise, sleep, mental health, nutrition, weight management,
					stress, and more.
				</p>
				<p [translate]="'health-coach.sections.wellness.coaching-appointment.health-coaching-appt-booked.body-2'">
					You can review your appointment details on the 'My Appointments' page. We look forward to seeing you soon!
				</p>
			</div>
			<div class="coaching-appt-button-container book-now">
				<button
					class="button"
					mat-button
					(click)="viewAppointment()"
					[translate]="
						'health-coach.sections.wellness.coaching-appointment.health-coaching-appt-booked.view-appointment-button'
					">
					View Appointment Details
				</button>
			</div>
		</div>
		<div class="coaching-appt-image-container">
			<div class="coaching-appt-image-wrapper coaching-appt-image-hc"></div>
		</div>
	</div>
</ng-container>
